<template>
  <div class="logo">
    <img src="~assets/images/pencils5-transparent-UK.png" :width="width" :height="height" />
  </div>
</template>

<script>
export default {
  props: {
    width: Number,
    height: Number
  }
}
</script>

<style scoped>
.logo {
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// Logo.vue?682027dd